import React from "react";

const Stat_Range = () => {
  return (
    <div>
      <h1>Stat Range</h1>
    </div>
  );
};

export default Stat_Range;
